import * as React from 'react';
import { Alert, Button, Checkbox } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Radium from 'radium';

import Field from '../components/field';

import { changeText, submitForm, validateField } from './actions';

const RPT = React.PropTypes;

@connect(
  ({ contact: { email, message, subject, privacy, submitted, errors, isLoading } }) => ({ email, message, subject, privacy, submitted, errors, isLoading }),
  { changeText, validateField, submitForm },
)
@Radium
export default class ContactForm extends React.Component {
  static propTypes = {
    email: RPT.string.isRequired,
    message: RPT.string.isRequired,
    subject: RPT.string.isRequired,
    privacy: RPT.bool.isRequired,
    submitted: RPT.bool.isRequired,
    isLoading: RPT.bool.isRequired,
    errors: RPT.objectOf(RPT.array).isRequired,
    changeText: RPT.func,
    submitForm: RPT.func.isRequired,
    validateField: RPT.func.isRequired
  };

  static defaultProps = {
    changeText: () => null
  }

  handleChange({ target: { name, value, checked } }) {
    const { changeText, validateField } = this.props;

    if (name === 'privacy') {
      validateField('privacy', !!checked);
      changeText({ name, value: !!checked });
    } else {
      changeText({ name, value });
    }
  }

  handleSubmit() {
    const { submitForm } = this.props;

    submitForm();
  }

  hasErrors() {
    const { errors } = this.props;

    return !!Object.keys(errors).some(key => errors[key].length > 0);
  }

  errorStatus(key) {
    const { errors } = this.props;

    if (errors[key] === undefined) { return undefined; }
    if (errors[key].length === 0) { return undefined; }

    return 'error';
  }

  render() {
    const { email, message, subject, privacy, submitted, isLoading } = this.props;

    this.hasErrors();

    return (<div data-tid="contact-form">
      {submitted && <Alert bsStyle="success">Děkujeme za dotaz.</Alert>}
      <Field name="email" label="E-mail" onChange={this.handleChange.bind(this)} value={email} errorState={this.errorStatus('email')} />
      <Field name="subject" label="Předmět" onChange={this.handleChange.bind(this)} value={subject} errorState={this.errorStatus('subject')} />
      <Field type="textarea" label="Zpráva" name="message" onChange={this.handleChange.bind(this)} value={message} errorState={this.errorStatus('message')} />
      <Checkbox name="privacy" onChange={this.handleChange.bind(this)} checked={privacy} validationState={privacy ? 'success' : 'error'}>
        Souhlasím se zpracováním osobních údajů podle <Link to="/zasady-osobnich-udaju" target="_blank">Zásad zpracování osobních údajů</Link>.
      </Checkbox>
      <Button type="submit" disabled={this.hasErrors() || isLoading} bsStyle="success" onClick={this.handleSubmit.bind(this)} style={{ width: '40%', marginLeft: '30%' }}>
        {isLoading ? 'Odesílání...' : 'Odeslat zprávu'}
      </Button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/contact_form/index.jsx